"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Options_options, _Options_authorization, _Options_timeout, _Options_metadata;
Object.defineProperty(exports, "__esModule", { value: true });
class Options {
    constructor(options = {}) {
        _Options_options.set(this, {});
        _Options_authorization.set(this, {});
        _Options_timeout.set(this, {});
        _Options_metadata.set(this, {});
        __classPrivateFieldSet(this, _Options_options, options, "f");
    }
    merge(options) {
        const raw = options.toObject();
        const newOptions = {
            ...__classPrivateFieldGet(this, _Options_options, "f"),
            ...raw,
        };
        if (__classPrivateFieldGet(this, _Options_options, "f").headers || raw.headers) {
            newOptions.headers = {
                ...__classPrivateFieldGet(this, _Options_options, "f").headers,
                ...raw.headers,
            };
        }
        const result = new Options(newOptions);
        __classPrivateFieldSet(result, _Options_authorization, {
            ...__classPrivateFieldGet(this, _Options_authorization, "f"),
            ...__classPrivateFieldGet(options, _Options_authorization, "f"),
        }, "f");
        __classPrivateFieldSet(result, _Options_metadata, {
            ...__classPrivateFieldGet(this, _Options_metadata, "f"),
            ...__classPrivateFieldGet(options, _Options_metadata, "f"),
        }, "f");
        __classPrivateFieldSet(result, _Options_timeout, {
            ...__classPrivateFieldGet(this, _Options_timeout, "f"),
            ...__classPrivateFieldGet(options, _Options_timeout, "f"),
        }, "f");
        return result;
    }
    set(options = {}) {
        const newOptions = {
            ...__classPrivateFieldGet(this, _Options_options, "f"),
            ...options,
        };
        if (__classPrivateFieldGet(this, _Options_options, "f").headers) {
            newOptions.headers = __classPrivateFieldGet(this, _Options_options, "f").headers;
        }
        if (__classPrivateFieldGet(this, _Options_options, "f").body) {
            newOptions.body = __classPrivateFieldGet(this, _Options_options, "f").body;
        }
        __classPrivateFieldSet(this, _Options_options, newOptions, "f");
        return this;
    }
    /**
     * Timeout a request using an [AbortController](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) object.
     *
     * If the remote servers doesn't repond in the timeframe the request Request
     * will fail with a 408 http error and will internally abort the request to
     * prevent memory leaks.
     *
     * If you want to return a fallback value instead of failing, use the `timeoutWithFallback`
     * method instead.
     */
    timeout(timeout) {
        __classPrivateFieldGet(this, _Options_timeout, "f").timeout = Math.max(0, timeout);
        return this;
    }
    /**
     * Timeout a request using an [AbortController](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) object.
     *
     * If the remote servers doesn't repond in the timeframe the request Request
     * will return the fallback parameter instead of failing and will internally
     * abort the request to prevent memory leaks.
     */
    timeoutWithFallback(timeout, fallback) {
        this.timeout(timeout);
        __classPrivateFieldGet(this, _Options_timeout, "f").timeoutFallback = fallback;
        return this;
    }
    authorization(options = { identity: true, optional: true }) {
        __classPrivateFieldSet(this, _Options_authorization, options, "f");
        return this;
    }
    header(key, value) {
        if (!__classPrivateFieldGet(this, _Options_options, "f").headers) {
            __classPrivateFieldGet(this, _Options_options, "f").headers = {};
        }
        key = key.toLowerCase();
        if (__classPrivateFieldGet(this, _Options_options, "f").headers[key]) {
            console.warn(`Can not set header "${key}" as "${value}" because is already defined as "${__classPrivateFieldGet(this, _Options_options, "f").headers[key]}"`);
        }
        else {
            __classPrivateFieldGet(this, _Options_options, "f").headers[key] = value;
        }
        return this;
    }
    headers(headers) {
        Object.keys(headers).forEach((key) => this.header(key.toLowerCase(), headers[key]));
        return this;
    }
    method(method) {
        __classPrivateFieldGet(this, _Options_options, "f").method = method;
        return this;
    }
    getMethod() {
        return __classPrivateFieldGet(this, _Options_options, "f").method || 'GET';
    }
    metadata(data) {
        __classPrivateFieldSet(this, _Options_metadata, {
            ...__classPrivateFieldGet(this, _Options_metadata, "f"),
            ...data,
        }, "f");
        return this;
    }
    getMetadata() {
        return __classPrivateFieldGet(this, _Options_metadata, "f");
    }
    json(data) {
        this.header('content-type', 'application/json');
        __classPrivateFieldGet(this, _Options_options, "f").body = JSON.stringify(data);
        return this;
    }
    getAuthorization() {
        return __classPrivateFieldGet(this, _Options_authorization, "f");
    }
    getTimeout() {
        return __classPrivateFieldGet(this, _Options_timeout, "f");
    }
    toObject(extend = {}) {
        return { ...__classPrivateFieldGet(this, _Options_options, "f"), ...extend };
    }
}
exports.default = Options;
_Options_options = new WeakMap(), _Options_authorization = new WeakMap(), _Options_timeout = new WeakMap(), _Options_metadata = new WeakMap();
